import { useState } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";

/* ===================== AUTH ===================== */
import Login from './pages/Login/Login';

/* ===================== COMMON ===================== */
import StoreSuccess from "./pages/gateway/StoreSuccess";
import StoreFailure from "./pages/gateway/StoreFailure";
import StoreResSuccess from './pages/gateway/StoreResSuccess';
import StoreResFailure from './pages/gateway/StoreResFailure';

import CustSuccess from "./pages/gateway/CustSuccess";
import CustFailure from "./pages/gateway/CustFailure";
import CustResSuccess  from './pages/gateway/CustResSuccess';
import CustResFailure  from './pages/gateway/CustResFailure';

import Footer  from "./pages/Footer/Footer";

import Dashboard     from "./pages/dashboard/Dashboard";
import DashboardPlus from "./pages/dashboard/DashboardPlus";

import PrintPhysicalCard from "./pages/printcard/PhysicalLoyaltyCard";
import PrintPhysicalBack from "./pages/printcard/PhysicalLoyaltyBack";
import PhysicalLoyaltyQr from "./pages/printcard/PhysicalLoyaltyQr";
import LuckyDrawCoupon   from "./pages/printcard/LuckyDrawCoupon";
import LuckyDrawCouponBack from "./pages/printcard/LuckyDrawCouponBack";
import LuckyDrawRedeem from "./pages/printcard/LuckyDrawRedeem";
import LuckyDrawCouponQr from "./pages/printcard/LuckyDrawCouponQr";

/* ===================== DASHBOARD ===================== */
import Navbar from "./components/dashboard/Navbar/Navbar";

import DashboardReport from "./components/dashboard/DashboardReport";
import Wallet from "./components/Wallet/Wallet";
import CouponList from "./components/dashboard/CouponList";
import CampaignList from "./components/dashboard/CampaignList";
import CreateCouponDialog from "./components/dashboard/CreateCouponDialog";
import CreatePromotionDialog from "./components/dashboard/CreatePromotionDialog";
import DialogBox from "./components/CommanComponents/DialogBox";
import { TotalValueDt,} from "./components/dashboard/ListingTables";
import { IssuedList } from "./components/dashboard/DashboardListing/IssuedList";
import { RedeemedList} from "./components/dashboard/DashboardListing/RedeemedList";
import { CustomerList } from "./components/dashboard/DashboardListing/CustomerList";
import { CustomerListDashbaord } from "./components/dashboard/DashboardListing/CustomerListDashbaord";
import { DashboardSaleReport } from "./components/dashboard/DashboardListing/DashboardSaleReport";
import StoreLoyaltySetting from "./components/dashboard/StoreLoyaltySetting";


/* ===================== DASHBOARD PLUS ===================== */

import DashboardPlusNavbar from "./components/DashboardPlus/Navbar/DashboardPlusNavbar";
import WalletPlus from "./components/DashboardPlus/WalletPlus/WalletPlus";
import LoadQR from "./components/DashboardPlus/QRCode/LoadQR";
import GenerateQRCode from "./components/DashboardPlus/QRCode/GenerateQRCode";
import PrintQRPlus from "./components/DashboardPlus/QRCode/PrintQRPlus";
import QR from "./components/DashboardPlus/QRCode/QR";
import LoadnActiveQR from "./components/DashboardPlus/QRCode/LoadnActiveQR";
import { GeneratedQR } from "./components/DashboardPlus/DashboardPlusListing/GeneratedQR";
import { ActivatedQR } from "./components/DashboardPlus/DashboardPlusListing/ActivatedQR";
import {LoadedQR} from "./components/DashboardPlus/DashboardPlusListing/LoadedQR";
import { TotalPlusCustomer } from "./components/DashboardPlus/DashboardPlusListing/TotalPlusCustomer";
import Redeemed from "./components/DashboardPlus/Redeemed";
import RedeemedCustHistory from "./components/DashboardPlus/RedeemedCustHistory";

// ------------------------------------------------------------------
// MAIN DASHBOARD LAYOUT
// ------------------------------------------------------------------
const DashboardLayout = ({ onLogout }) => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar onLogout={onLogout} />

    <div style={{ flex: 1 }}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="DashboardReport" element={<DashboardReport />} />

        <Route path="issuedList" element={<IssuedList />} />
        <Route path="redeemedList" element={<RedeemedList />} />
        <Route path="customerList" element={<CustomerList />} />
        <Route path="totalvalue" element={<TotalValueDt />} />

        <Route path="printphysicalcard" element={<PrintPhysicalCard />} />
        <Route path="printphysicalback" element={<PrintPhysicalBack />} />
        <Route path="printphysicalqr" element={<PhysicalLoyaltyQr />} />

        
        <Route path="luckydrawcoupon" element={<LuckyDrawCoupon />} />
        <Route path="luckydrawcouponback" element={<LuckyDrawCouponBack />} />
        <Route path="luckydrawcouponQr" element={<LuckyDrawCouponQr />} />
        <Route path="luckydrawredeem" element={<LuckyDrawRedeem />} />

        <Route path="createcoupon" element={<CreateCouponDialog />} />
        <Route path="createpromotion" element={<CreatePromotionDialog />} />

        <Route path="wallet" element={<Wallet />} />
        <Route path="couponlist" element={<CouponList />} />
        <Route path="campaignList" element={<CampaignList />} />

        <Route path="customerlistdashbaord" element={<CustomerListDashbaord />} />
        <Route path="dashboardsalereport" element={<DashboardSaleReport />} />
        <Route path="loyaltysetting" element={<StoreLoyaltySetting />} />

        <Route path="dialogbox" element={<DialogBox />} />
        <Route path="success" element={<StoreSuccess />} />
        <Route path="failure" element={<StoreFailure />} />
      </Routes>
    </div>

    <Footer />
  </div>
);

// ------------------------------------------------------------------
// DASHBOARD PLUS LAYOUT
// ------------------------------------------------------------------
const DashboardPlusLayout = ({ onLogout }) => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <DashboardPlusNavbar onLogout={onLogout} />
    
    <div style={{ flex: 1 }}>
      <Routes>
        <Route index element={<DashboardPlus />} />

        <Route path="generatedQR" element={<GeneratedQR />} />
        <Route path="activatedQR" element={<ActivatedQR />} />
        <Route path="loadedQR" element={<LoadedQR />} />
        <Route path="loadnactiveqr" element={<LoadnActiveQR />} />

        <Route path="totalPlusCustomer" element={<TotalPlusCustomer />} />
        <Route path="generateQR" element={<GenerateQRCode />} />
        <Route path="qr" element={<QR />} />
        <Route path="printQR" element={<PrintQRPlus />} />
        <Route path="loadQR" element={<LoadQR />} />

        <Route path="walletPlus" element={<WalletPlus />} />
        <Route path="redeemed" element={<Redeemed />} />
        <Route path="redeemed/redeemedcusthistory" element={<RedeemedCustHistory />} />

        <Route path="success" element={<StoreSuccess />} />
        <Route path="failure" element={<StoreFailure />} />
      </Routes>
    </div>

    <Footer />
  </div>
);

/* ================================================= */
/* ================= PUBLIC ROUTES ================= */
/* ================================================= */

const PublicRoutes = ({ onLogin }) => (
  <Routes>
    <Route path="/" element={<Login onLogin={onLogin} />} />
    <Route path="/store_pay_sucsess" element={<StoreResSuccess />} />
    <Route path="/store_pay_failure" element={<StoreResFailure />} />
    <Route path="/cust_pay_sucsess"  element={<CustResSuccess />} />
    <Route path="/cust_pay_failure"  element={<CustResFailure />} />   
    <Route path="csuccess" element={<CustSuccess />} />
    <Route path="cfailure" element={<CustFailure />} /> 
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

// ------------------------------------------------------------------
// APP ROUTES
// ------------------------------------------------------------------
const AppRoutes = () => 
{
  const navigate = useNavigate();

  const [isAuthenticated, setIsAuthenticated] = useState(sessionStorage.getItem("authenticated") === "true");
  
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const cashiPlusFlag = user?.store_info?.cashi_plus_flag;

  const handleLogin = (userData) => 
  {
    sessionStorage.setItem("authenticated", "true");
    setIsAuthenticated(true);   

    const cashiPlusFlag = userData?.store_info?.cashi_plus_flag;
  
    if (cashiPlusFlag === "2") { navigate("/dashboardPlus"); }
    else 
    {
      navigate("/dashboard");
    }

  };

  const handleLogout = () => 
  {
      sessionStorage.clear();
      setIsAuthenticated(false);
      navigate("/");
  };

  if (!isAuthenticated) 
  {
    return <PublicRoutes onLogin={handleLogin} />;
  }

  return (
    <Routes>   
      {/* Dashboard Plus Layout */}
      <Route path="/dashboardPlus/*" element={(cashiPlusFlag === "1" || cashiPlusFlag === "2") ? 
          <DashboardPlusLayout onLogout={handleLogout} /> : <Navigate to="/dashboard" replace />} />

      {/* Default Dashboard Layout */}
      <Route path="/*" element={cashiPlusFlag === "2" ? <Navigate to="/dashboardPlus" replace />: <DashboardLayout onLogout={handleLogout} />} />

    </Routes>
  );
};

export default AppRoutes;
